'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bookmakersMap;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _rpAnalytics = require('rp-analytics');

var segmentio = _interopRequireWildcard(_rpAnalytics);

var _rpDiffusionConnector = require('rp-diffusion-connector');

var _DiffusionServiceUtils = require('./utils/DiffusionServiceUtils');

var _ToteBookmakersNameMap = require('./utils/ToteBookmakersNameMap');

var _PricesStateStore = require('./stores/PricesStateStore');

var _DIFFUSION = require('./constants/DIFFUSION');

var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);

var _PreloadedStateHelper = require('../js/utils/PreloadedStateHelper');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var nonIntegratedBookieList = {
    BOLEYSPORTS: {
        url: 'https://www.boylesports.com/Betslip/AddToBetslip?selId=[$outcomeId]&idfiacampaign=32667',
        width: 1000,
        height: 600,
        name: 'BOLEYSPORTS'
    },
    VC: {
        url: 'http://www.betvictor.com/sports/en/coupon/remotes?outcomeids=[[$outcomeId]00]&btagid=90081080',
        width: 986,
        height: 600,
        name: 'VC'
    },
    TOTE: {
        url: 'https://tote.co.uk/racecards/[$meeting-name]/today/[$time]/win?selections=[$selections]&utm_source=racingpost&utm_medium=partner-editoral&utm_campaign=oddsgrid&utm_content=odds-grid',
        width: 1050,
        height: 500,
        name: 'TOTE'
    },
    BETFRED: {
        url: 'https://www.betfred.com/affiliates?affiliate_id=101891&btag=113519&targeturl=https://www.betfred.com/external-betslip?selection=[$outcomeId]',
        width: 1050,
        height: 500,
        name: 'BETFRED'
    }
};

var bookmakersMap = (_bookmakersMap = {
    BET365: 'bet365',
    LADB: 'Ladbrokes',
    WH_OXI: 'William Hill',
    CORAL: 'Coral',
    PPWR: 'Paddy Power',
    BETFAIR: 'Betfair',
    VC: 'BetVictor'
}, _defineProperty(_bookmakersMap, _PreloadedStateHelper.skybetDiffusionName, 'Sky bet'), _defineProperty(_bookmakersMap, 'BOLEYSPORTS', 'Boylesport'), _defineProperty(_bookmakersMap, 'TOTE', 'Tote'), _defineProperty(_bookmakersMap, '#BESTODDS', 'Best Odds'), _bookmakersMap);

var LOCATION_DATA_ATTRIBUTE = 'data-price-location';
var RACE_ID_DATA_ATTRIBUTE = 'data-diffusion-race-id';
var DATA_RACE_DATE_TIME = 'data-card-race-date-time';
var DATA_DIFFUSION_RACE_TIME = 'data-diffusion-racetime';

function isPriceButtonClicked($priceElement) {
    var invalidPricePattern = /^[\s,\-,NR]{1,}$/;
    return $priceElement.length && !$priceElement.text().match(invalidPricePattern);
}

function getBookmakerName($priceElement) {
    var bookieRow = $priceElement.closest('[' + _DIFFUSION2.default.DATA.INPUT.BOOKMAKER + ']')[0];
    if (bookieRow) {
        var bookmaker = bookieRow.getAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER);
        if (bookmaker) {
            return bookmaker;
        }
    }
    return _PricesStateStore.pricesStateStore.getCurrentBookmaker();
}

function isBookmakerIntegrated(bookmakerName) {
    return !!nonIntegratedBookieList[bookmakerName];
}

function setLocationfromURL() {
    var location = window.location.href;
    if (location.indexOf('horse-tracker') > -1) return 'Horse Tracker';

    if (location.indexOf('profile') > -1) {
        if (location.indexOf('horse') > -1) return 'Horse Profile';
        if (location.indexOf('jockey') > -1) return 'Jockey Profile';
        if (location.indexOf('owner') > -1) return 'Owner Profile';
        if (location.indexOf('trainer') > -1) return 'Trainer Profile';
    }

    if (location.indexOf('tipping') > -1) return 'Tipping Article';
    if (location.indexOf('news') > -1) return 'News Article';

    return 'Undefined location';
}

function trackBetButtonClickAnalytics(bookieName, location, selectionData) {
    var _config;

    var bookmaker = Object.prototype.hasOwnProperty.call(bookmakersMap, bookieName) ? bookmakersMap[bookieName] : bookieName;
    var trackLocation = void 0;

    if (location) {
        trackLocation = location;
    } else {
        trackLocation = setLocationfromURL();
    }

    var config = (_config = {}, _defineProperty(_config, segmentio.TRAIT_LOCATION, trackLocation), _defineProperty(_config, segmentio.TRAIT_BOOKMAKER, bookmaker), _defineProperty(_config, segmentio.TRAIT_PRICE, selectionData.priceType), _defineProperty(_config, segmentio.TRAIT_HORSE_NAME, selectionData.horseName), _config);

    segmentio.identify(undefined, config).then(function () {
        return segmentio.trackBetButtonClick(config);
    });
}

/* eslint-disable class-methods-use-this */

var BetHandler = function () {
    function BetHandler() {
        _classCallCheck(this, BetHandler);

        this.bindEvents();
    }

    _createClass(BetHandler, [{
        key: 'bindEvents',
        value: function bindEvents() {
            var $body = (0, _jquery2.default)('body');

            $body[0].addEventListener('click', this.makeSelectionHandler.bind(this), true, { once: true });
            $body.on('RC.makeSelection', this.makeSelection.bind(this));
        }
    }, {
        key: 'makeSelectionHandler',
        value: function makeSelectionHandler(event) {
            var $priceElement = (0, _jquery2.default)(event.target).closest('.js-betHandler');

            if (!(0, _rpDiffusionConnector.shouldEstablishSession)()) {
                return;
            }
            if (!isPriceButtonClicked($priceElement)) {
                return;
            }
            event.preventDefault();

            var horseElement = $priceElement.closest('.js-diffusionHorsesList')[0] || $priceElement.closest('.js-diffusionBestOdds')[0];
            var raceId = _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(RACE_ID_DATA_ATTRIBUTE, horseElement);

            if (!raceId) {
                // eslint-disable-next-line no-console
                console.error('Making selection required parameter missing');
                return;
            }

            var id = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID);
            var fractionalPrice = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL);
            var decimalPrice = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL);
            var isSp = fractionalPrice === 'SP';
            var price = isSp ? null : fractionalPrice;
            var eventId = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID);
            var meetingId = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID);
            var marketId = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.MARKET_ID);
            var bookmaker = getBookmakerName($priceElement);

            var courseName = _DiffusionServiceUtils.diffusionServiceUtils.getTopicCourseName(horseElement);
            var horseName = horseElement.getAttribute(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME);
            var raceTime = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceTime(horseElement);
            // eslint-disable-next-line max-len
            // data-card-race-date-time is not available for racecards index, so we're using diffusion racetime data-diffusion-racetime
            var dataRaceDateTime = _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(DATA_RACE_DATE_TIME, horseElement) || _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(DATA_DIFFUSION_RACE_TIME, horseElement);
            var raceDate = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceDate(horseElement);
            var location = _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(LOCATION_DATA_ATTRIBUTE, horseElement);
            var userMD5 = _jsCookie2.default.get('RP_MD5_COOKIE');
            var topic = _DiffusionServiceUtils.diffusionServiceUtils.createInfoTopic({
                courseName: courseName,
                raceTime: raceTime,
                raceDate: raceDate,
                bookmaker: bookmaker
            });

            var startNumberElements = (0, _jquery2.default)('.RC-runnerNumber__no[data-horseName="' + horseName + '"]');
            // eslint-disable-next-line max-len
            var startNumber = startNumberElements.length ? Number(startNumberElements[0].innerHTML) : null;

            var getCourseName = courseName.toUpperCase();
            var getToteCourseName = getCourseName in _ToteBookmakersNameMap.toteCourseNameMapping ? _ToteBookmakersNameMap.toteCourseNameMapping[getCourseName] : courseName;
            var ToteTimeObj = new Date(dataRaceDateTime);
            var setToteRaceTime = void 0;
            // dateRaceTime comes as a HH:MM format from diffusion on racecards index, so no need to convert it
            if (!isNaN(ToteTimeObj)) {
                var formatMinutes = ToteTimeObj.getMinutes() < 10 ? '0' + ToteTimeObj.getMinutes() : ToteTimeObj.getMinutes();
                setToteRaceTime = ToteTimeObj.getHours() + ':' + formatMinutes;
            } else setToteRaceTime = raceTime;

            var selectionData = {
                selectionInfo: {
                    id: id,
                    price: price,
                    fractionalPrice: fractionalPrice,
                    decimalPrice: decimalPrice,
                    isSp: isSp,
                    eventId: eventId,
                    meetingId: meetingId,
                    marketId: marketId,
                    data: {
                        horseName: horseName,
                        courseName: courseName.toLowerCase(),
                        raceDate: raceDate,
                        time: raceTime,
                        eachWayTopic: topic,
                        infoTopic: topic,
                        raceId: raceId
                    },
                    toteUrlParams: {
                        horseName: horseName.replace(/[\W_]/g, '-').toLowerCase(),
                        courseName: getToteCourseName.replace(/[\W_]/g, '-').toLowerCase(),
                        time: setToteRaceTime,
                        startNumber: startNumber
                    }
                },
                bookieName: bookmaker,
                userMD5: userMD5,
                priceElement: $priceElement
            };
            this.makeSelection(event, selectionData);

            if ((0, _jquery2.default)(event.target).hasClass('added-to-betslip')) {
                var priceType = isSp ? 'SP' : 'Odds';

                trackBetButtonClickAnalytics(bookmaker, location, {
                    priceType: priceType,
                    horseName: horseName
                });
            }
        }
    }, {
        key: 'onNotIntegratedBookmakerSelected',
        value: function onNotIntegratedBookmakerSelected(data) {
            var bookieName = data.bookieName,
                _data$selectionInfo = data.selectionInfo,
                outcomersId = _data$selectionInfo.id,
                price = _data$selectionInfo.price,
                isSp = _data$selectionInfo.isSp,
                priceElement = data.priceElement;

            var notIntegratedBookmaker = nonIntegratedBookieList[bookieName];
            var dividend = '';
            var divider = '';
            if (!isSp) {
                var splitedPrice = price.split('/');
                dividend = splitedPrice[0];
                divider = splitedPrice[1];
            }

            var toteHorseName = data.selectionInfo.toteUrlParams.horseName;
            var toteCorseName = data.selectionInfo.toteUrlParams.courseName;
            var toteRaceTime = data.selectionInfo.toteUrlParams.time;
            var isOddsComparisonTable = window.location.href.split('/').indexOf('odds-comparison') > 0;
            var selections = data.selectionInfo.toteUrlParams.startNumber;
            // tote replacing are [$meeting-name]/[$time]/[$runner-name]/win'

            var url = notIntegratedBookmaker.url.replace('[$runner-name]', toteHorseName).replace('[$time]', toteRaceTime).replace('[$meeting-name]', toteCorseName).replace('[$selections]', selections).replace('[$outcomeId]', outcomersId).replace('[$dividend]', dividend).replace('[$divider]', divider).replace('[$price]', data.selectionInfo.price || '').replace('[$userMD5]', !data.userMD5 ? 'no_MD5_cookie' : data.userMD5).replace('[$eventId]', data.selectionInfo.eventId).replace('[$meetingId]', data.selectionInfo.meetingId).replace('[$utm_content]', isOddsComparisonTable ? 'oddscomparison' : 'racecardsodds');

            priceElement.attr('href', url).attr('data-popup-width', notIntegratedBookmaker.width).attr('data-popup-height', notIntegratedBookmaker.height).attr('data-popup-blank', true).addClass('js-popupLink');
        }
    }, {
        key: 'onIntegratedBookmakerSelected',
        value: function onIntegratedBookmakerSelected(data) {
            var bookieName = data.bookieName,
                _data$selectionInfo2 = data.selectionInfo,
                meetingId = _data$selectionInfo2.meetingId,
                _data$selectionInfo2$ = _data$selectionInfo2.data,
                courseName = _data$selectionInfo2$.courseName,
                raceDate = _data$selectionInfo2$.raceDate,
                time = _data$selectionInfo2$.time;

            var _pricesStateStore$get = _PricesStateStore.pricesStateStore.getRaceInfo({
                bookmaker: bookieName,
                courseName: courseName.toUpperCase(),
                raceDate: raceDate,
                raceTime: time
            }),
                suspendState = _pricesStateStore$get.suspendState,
                winOdds = _pricesStateStore$get.winOdds,
                placeWinner = _pricesStateStore$get.placeWinner,
                isBog = _pricesStateStore$get.isBog;

            _extends(data.selectionInfo, {
                suspendState: suspendState,
                eachWayFraction: winOdds,
                eachWayPlaces: placeWinner,
                isBog: isBog
            });
            var raceId = data.selectionInfo.data.raceId;
            var outcomersId = data.selectionInfo.id;

            if (window.betslipApi && window.betslipApi.isHorseSelected(raceId, outcomersId, meetingId)) {
                var removeSelectionEvent = new CustomEvent('BETSLIP.REMOVE_SELECTION', { detail: data });
                document.dispatchEvent(removeSelectionEvent);
                // for back compatibility (temporary)
                _jquery2.default.event.trigger('BETSLIP.REMOVE_SELECTION', _extends({}, data));
            } else {
                var makeSelectionEvent = new CustomEvent('BETSLIP.MAKE_SELECTION', { detail: data });
                document.dispatchEvent(makeSelectionEvent);
                // for back compatibility (temporary)
                _jquery2.default.event.trigger('BETSLIP.MAKE_SELECTION', _extends({}, data));
            }
        }
    }, {
        key: 'makeSelection',
        value: function makeSelection(event, data) {
            var bookieName = data.bookieName;

            if (isBookmakerIntegrated(bookieName)) {
                this.onNotIntegratedBookmakerSelected(data);
            } else if (data.bookieName !== '#BESTODDS') {
                this.onIntegratedBookmakerSelected(data);
            }
        }
    }]);

    return BetHandler;
}();
/* eslint-enable class-methods-use-this */

exports.default = BetHandler;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/BetHandler.js
// module id = 2690
// module chunks = 0